import { toast } from "react-toastify";
import { executePost } from "../ServiceMethods";
import { SessionTimeout } from "../ErrorMessages";
import { removeUserCredentials } from "../LocalStorage";

export const CouponAIResApi = async (data, cb) => {
    try {
        const CouponAIRes = await executePost(
            "/shoplocalai/coupondescription",
            data
        );
        const CouponAIResData = CouponAIRes.data
            ? CouponAIRes.data
            : [];
        return CouponAIResData;
    } catch (error) {
        if (error.response.data.message === "Token is invalid!") {
            toast.dismiss();
            toast.clearWaitingQueue();
            toast.error(SessionTimeout, {
                position: "top-center",
                width: "500px",
                autoClose: 6000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
            removeUserCredentials();
            if (cb) {
                cb();
            }
        } else {
            return false;
        }
    }
};
